import React, { useEffect, useState } from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import { FaApple, FaAndroid } from "react-icons/fa";
import Card from "../../../components/Card";
import { getSubscriptionsStats } from "../../../api/stats.service";
import { chargeEur } from "../../Subscriptions/subMoney";
import styles from "./UpcomingSubs.module.sass";

/**
 * Agenda de suscripciones en el Home: qué se cobra y quién se va en los
 * próximos 7 días. Detalle completo en /subscriptions (pestaña Próximos).
 */

const LABEL = {
  paying: { what: "Renovación", tone: "good", money: true },
  trial: { what: "Primer cobro", tone: "good", money: true },
  paying_cancelled: { what: "Se va", tone: "bad" },
  trial_cancelled: { what: "Prueba sin pagar", tone: "bad" },
  grace: { what: "Último reintento", tone: "warn" },
};
const PLAN = { monthly: "Mensual", yearly: "Anual", lifetime: "Lifetime" };
const eur = (v) =>
  new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(v || 0);
const relDay = (d) => {
  const cal = (x) => Date.UTC(new Date(x).getFullYear(), new Date(x).getMonth(), new Date(x).getDate()) / 864e5;
  const x = cal(d) - cal(new Date());
  return x < 0 ? "ayer" : x === 0 ? "hoy" : x === 1 ? "mañana" : `en ${x} días`;
};

const UpcomingSubs = ({ className }) => {
  const [rows, setRows] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    getSubscriptionsStats()
      .then((r) => {
        if (r?.status === 200) setRows(r.data.rows);
        else {
          setRows([]);
          setFailed(true);
        }
      })
      .catch(() => {
        setRows([]);
        setFailed(true);
      });
  }, []);

  const now = Date.now();
  const ev = (rows ?? [])
    .filter((r) => LABEL[r.state] && r.accessUntil)
    .filter((r) => {
      const t = new Date(r.accessUntil).getTime();
      return t >= now - 864e5 && t <= now + 7 * 864e5;
    })
    .sort((a, b) => new Date(a.accessUntil) - new Date(b.accessUntil));
  const money = ev.filter((r) => LABEL[r.state].money).reduce((a, r) => a + chargeEur(r, "first"), 0);

  return (
    <Card
      className={cn(styles.card, className)}
      title="Suscripciones · próximos 7 días"
      classTitle="title-yellow"
      head={
        <Link className={styles.link} to="/subscriptions?tab=proximos">
          Ver agenda ›
        </Link>
      }
    >
      {rows === null ? (
        <div className={styles.empty}>Cargando…</div>
      ) : failed ? (
        <div className={styles.empty}>No se pudo cargar</div>
      ) : ev.length === 0 ? (
        <div className={styles.empty}>Nada previsto esta semana</div>
      ) : (
        <>
          <div className={styles.summary}>
            <strong>{ev.filter((r) => LABEL[r.state].money).length}</strong> cobros ≈ {eur(money)} ·{" "}
            <strong>{ev.filter((r) => LABEL[r.state].tone === "bad").length}</strong> se van
          </div>
          <div className={styles.list}>
            {ev.slice(0, 6).map((r) => {
              const meta = LABEL[r.state];
              return (
                <div key={r._id} className={styles.item}>
                  <span className={cn(styles.dot, styles[meta.tone])} />
                  <div className={styles.who}>
                    <div className={styles.name}>{r.user?.name || r.user?.email || "Sin usuario"}</div>
                    <div className={styles.sub}>
                      {r.platform === "APPLE" ? <FaApple size={10} /> : <FaAndroid size={10} color="#3DDC84" />} {PLAN[r.plan]} · {relDay(r.accessUntil)}
                    </div>
                  </div>
                  <span className={cn(styles.what, styles[meta.tone])}>{meta.what}</span>
                </div>
              );
            })}
          </div>
        </>
      )}
    </Card>
  );
};

export default UpcomingSubs;
